/** Internal dependencies */
import { isOverflown } from '../../../../../../assets/src/scripts/utilities';

export function setAlertSize() {
    const alerts = document.querySelectorAll('.heroslider--alert .heroslider-alert');

    if (!alerts) {
        return;
    }

    alerts.forEach((alert) => {
        let initSize = 100;
        alert.style.setProperty('--alert-triangle-size', `${initSize}px`);

        while (isOverflown(alert)) {
            initSize = initSize + 20;
            alert.style.setProperty('--alert-triangle-size', `${initSize}px`);
        }
    });
}
